module.exports = __webpack_public_path__ + "img/resource_01_m.96c12848.png";